import React from 'react';
import { FAQ } from '@/components/ui/faq-section';

const FAQSection = () => {
  return (
    <div id="faq" className="faq-section-wrapper">
      <FAQ />
    </div>
  );
};

export default FAQSection;